import { render, staticRenderFns } from "./labelSwitch.vue?vue&type=template&id=4391ca70&scoped=true"
import script from "./labelSwitch.vue?vue&type=script&lang=js"
export * from "./labelSwitch.vue?vue&type=script&lang=js"
import style0 from "./labelSwitch.vue?vue&type=style&index=0&id=4391ca70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4391ca70",
  null
  
)

export default component.exports